/**
 * About Us copy, mirrored from facilonservices.co.in/about-us.
 * Update here when the published page changes — this is the only copy in the app.
 */

export interface BoardMember {
  name: string;
  role: string;
  highlights: string[];
}

export const CORPORATE_PROFILE: string[] = [
  'Facilon Services Private Limited (“Facilon”), is a private limited company incorporated under Indian laws (Companies Act, 2013) in June 2023 and is promoted by Mr. Suneet Luthra and Mr. Jaydeep Jayakar.',
];

export const GOVERNMENT_RECOGNITION_INTRO =
  'Facilon is registered / recognised by Government of India as follows:';

export const GOVERNMENT_RECOGNITION: string[] = [
  'As a startup by the Department for Promotion of Industry and Internal Trade.',
  'As a Micro enterprise with Ministry of Micro, Small and Medium Enterprises.',
];

export const CORPORATE_PROFILE_TAIL: string[] = [
  'Facilon’s logo is registered with Trademark Registry of Government of India.',
  'The term ‘Facilon’ can be considered as a “mnemonic” which is derived from the two words viz “Facilitating” and “On-boarding” which are part of Facilon’s Logo.',
];

export const BUSINESS_ACTIVITY_INTRO: string[] = [
  'Facilon is a facilitator. Facilon is not a Financial / Investment / Wealth Adviser nor a Financial / Investment / Insurance Product distributor.',
  'Facilon offers a comprehensive platform designed to streamline operations for Service Providers viz Brokers, Custodians, Banks, Portfolio Managers etc., while enhancing the experience for their clients, who are investors or their investment advisors.',
];

export const BUSINESS_ACTIVITY_POINTS: string[] = [
  'For Service Providers, Facilon offers solution for facilitating client access to Service Provider products and efficient onboarding of these clients.',
  'For Investors and their Investment Advisors (including Wealth Managers, External Asset Managers - collectively referred as ‘Service Recipients’ or ‘SR’), Facilon provides solutions for facilitating interaction with these SPs through their pre-onboarding, onboarding and post onboarding investment journey.',
];

export const BUSINESS_ACTIVITY_TAIL: string[] = [
  'Facilon is a market place where the documents and information flow is intended to achieve the certain key objectives to Service Recipients and Service Providers.',
  'Facilon acts as a bridge or a facilitator to electronically facilitate the flow of information (in the form of data, documents, comments, observations etc) between onshore parties such as custodians, designated depository participants (DDPs), depository participants, brokers, banks, portfolio managers, investment funds and identified tax consultant on one side (“Service Provider”/ “SP”) and onshore/offshore (foreign parties) such as investors (institutions, body corporate or individuals such as NRIs, OCIs or foreign resident individuals), investment advisors and professional firms, who can source investors on other side (“Service Recipient”/“SR”).',
];

export const MISSION =
  'Our Mission is to provide innovative, efficient and secure solutions to investors and their advisors, seeking services from Brokers, Custodians, Banks, Investment Funds and related providers.';

export const VISION =
  'Our Vision is to facilitate efficient onboarding of investors with service providers and digitally enable their interactions with a selection of brokers, custodians, banks, asset managers, and associated service providers.';

export const PRODUCTS_INTRO: string[] = [
  'Please refer to our website www.facilonservices.com for more details.',
  'Our website has two important links:',
];

export const PRODUCTS_POINTS: string[] = [
  'Link to the Platform stated above to enable Service Providers to offer their products and Investors and potential investors to evaluate and appoint/select service providers.',
  'Section/tab dedicated to investors and potential investors on the process, applicable regulations, eligibility criteria, pre-requisites etc. and our products and services.',
];

export const PRODUCTS_TAIL =
  'These products may evolve in due course depending on market/regulatory dynamics and practices.';

export const BOARD_INTRO =
  'Our board members are veterans from the Securities Services industry with extensive experience and domain knowledge of Indian and international securities markets.';

export const BOARD_MEMBERS: BoardMember[] = [
  {
    name: 'Suneet Luthra',
    role: 'CEO & Co-Founder',
    highlights: [
      '30+ years in Indian & International Securities Market',
      'Ex-JPMorgan, Ex-Morgan Stanley, Ex-PWC',
      'Set-up fund accounting operations for Morgan Stanley Growth Fund',
      'Managed Service Provider relationships for Morgan Stanley and JPMorgan in Asia Pacific',
      'Worked with Service Providers and developed various solutions for Institutional Investors',
      'Involved in several Service Provider and Client Due Diligence exercises',
      'Defined & executed local and global custody strategy for JPMorgan in Asia Pacific',
      'Managed Custody Product for Asia Pacific Region at JP Morgan Chase',
      'Instrumental in setting up Direct Custody & Clearing Product in China, Hong Kong and India',
      'Well networked within India and globally with market participants and intermediaries',
    ],
  },
  {
    name: 'Jaydeep Jayakar',
    role: 'CAO & Co-Founder',
    highlights: [
      '40+ years in Branch, Treasury, Transaction, Investment Banking, Custody and Securities Services – Operations and Client Management',
      'Ex-SCB and freelance consultant in Securities Services',
      'Well versed with RBI (FERA / FEMA) and SEBI regulations, market practices in India and key overseas jurisdictions',
      'Managed business relationship with foreign and domestic institutional investors',
      'Experience in litigation support and forensic banking for regulatory agencies in India and the UK',
      'Domain expertise in Indian Capital Markets, Legal and Risk Management, Private Equity, and Structured Transactions',
      'Well networked within India with market participants and intermediaries',
    ],
  },
  {
    name: 'Rajiv Shah',
    role: 'CXO & Director',
    highlights: [
      '30+ years in Custodial Services, Global Custodian, and Insurance Sector',
      'Ex-JP Morgan Chase, Ex-Reliance Life Insurance, Ex-Stockholding Corp of India Ltd',
      'Domain and regulatory knowledge of Indian Capital Markets & Life Insurance industry',
      'Experience in Service Delivery and Customer Service in Custody and Life Insurance',
      'Strong skills in Operations Risk Management and Strategy Implementation',
      'Set-up Customer Service desk at global custodian and operations desk at leading Life Insurance Company',
      'Well networked within India with market participants and intermediaries',
    ],
  },
];
